import { useState, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_input-box.scss';

const propTypes = {
	/**
	 * Input contenido en la caja.
	 */
	input: PropTypes.element,
	/**
	 * Descripción de la caja,
	 * ubicada en la parte inferior.
	 */
	text: PropTypes.string,
	/**
	 * Link asociado a la caja.
	 */
	link: PropTypes.element,
	/**
	 * Flag, ¿contiene error?
	 */
	error: PropTypes.bool,
	/**
	 * Flag, ¿estado exitoso?
	 */
	success: PropTypes.bool,
	/**
	 * Flag, ¿está deshabilitado?
	 */
	disabled: PropTypes.bool,
	/**
	 * Clases adicionales.
	 */
	className: PropTypes.string,
};

const InputBox = ({ input, text, link, error, success, disabled, className, ...r }) => {
	const [isActive, setIsActive] = useState(false);
	const classes = classNames('input-box', className, {
		'state--error': error,
		'state--success': success,
		'state--disabled': disabled,
		'state--active': isActive,
	});

	return (
		<div className={classes} tabIndex="0" {...r}>
			<div className="main">
				{cloneElement(input, { setIsActive })}
				{link && <div className="link">{link}</div>}
			</div>
			{text && <div className="description --fivexs">{text}</div>}
		</div>
	);
};

InputBox.propTypes = propTypes;

export default InputBox;
